/**
 * Comppoints Replacer Model
 */

define(function(require, exports, module) {
    'use strict';
    var BaseModel = require('common/base.model'),
        server = require('server');

    module.exports = BaseModel.extend({

        idAttribute: 'total',

        process: null,

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.getCompoints(model, options);
            }
        },

        parse: function(response) {
            return response.data;
        },

        /**
         * Get information about user compoints
         * @param  {Model} model
         * @param  {Object} options
         * @return {Deferred}
         */
        getCompoints: function(model, options) {
            if (this.process && this.process.state() === 'pending') {
                return this.process;
            }

            return this.process = server.send({
                ID: 35203,
                description: 'Get Comp Points',
                responses: [35204, 35205]
            }).done(options.success).fail(options.error);
        },

        /**
         * Convert user compoints to money
         * @return {Deferred}
         */
        convertToMoney: function() {
            return server.send({
                ID: 35206,
                description: 'Convert Comp Points to Real Money',
                responses: [35207, 35208]
            });
        },

        /**
         * Override clear method (remove process)
         */
        clear: function() {
            this.process = null;

            return BaseModel.prototype.clear.call(this);
        }

    });
});